import { Select as MantineSelect } from "@mantine/core"
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react"
import { useRef, useState } from "react";

export const Select = (props) => {

    const [isOpen, setIsOpen] = useState(false);

    const handleDropdownOpen = () => {
        setIsOpen(true);
        if (props.onDropdownOpen) {
            props.onDropdownOpen(); // Call the parent-provided onDropdownOpen, if it exists
        }
    };

    const handleDropdownClose = () => {
        setIsOpen(false);
        if (props.onDropdownClose) {
            props.onDropdownClose(); // Call the parent-provided onDropdownClose, if it exists
        }
    };

    return (
        <MantineSelect
            onDropdownOpen={handleDropdownOpen}
            onDropdownClose={handleDropdownClose}
            rightSection={isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
            comboboxProps={{ transitionProps: { transition: 'pop', duration: 100 } }}
            {...props}
        />
    )
}